/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteSublimitCommand } from '../models/DeleteSublimitCommand';
import type { EditSublimitCommand } from '../models/EditSublimitCommand';
import type { SublimitDtoPaginatedResult } from '../models/SublimitDtoPaginatedResult';
import type { UploadFacilityDocumentDto } from '../models/UploadFacilityDocumentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SublimitsService {
    /**
     * @param id
     * @param formData
     * @returns string OK
     * @throws ApiError
     */
    public static putApiSublimitsDocuments(
        id: string,
        formData?: {
            Data?: Array<UploadFacilityDocumentDto>;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Sublimits/{id}/documents',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param pageNumber
     * @param pageSize
     * @param sortBy
     * @param sortOrder
     * @param filterByAvailableStartDate
     * @param filterByAvailableEndDate
     * @param filterBySublimitType
     * @param filterByFacilityCategory
     * @returns SublimitDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiSublimitsFacility(
        id: string,
        pageNumber?: number,
        pageSize?: number,
        sortBy?: string,
        sortOrder?: string,
        filterByAvailableStartDate?: string,
        filterByAvailableEndDate?: string,
        filterBySublimitType?: Array<string>,
        filterByFacilityCategory?: Array<string>,
    ): CancelablePromise<SublimitDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Sublimits/facility/{id}',
            path: {
                'id': id,
            },
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'FilterByAvailableStartDate': filterByAvailableStartDate,
                'FilterByAvailableEndDate': filterByAvailableEndDate,
                'FilterBySublimitType': filterBySublimitType,
                'FilterByFacilityCategory': filterByFacilityCategory,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiSublimits(
        id: string,
        requestBody?: DeleteSublimitCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Sublimits/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static patchApiSublimits(
        id: string,
        requestBody?: EditSublimitCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/Sublimits/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
